module.exports = __webpack_public_path__ + "static/oes_welfare.dca8428a.png";